import React, { Fragment, useContext, useEffect } from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';
import { Tag, TagBlockProps } from '../Tag';

import CardContentContext from './CardContentContext';
import { useApplyTagsStyle } from './logic';

export interface CardContentTagsProps extends DefaultBsComponent {
  tags?: TagBlockProps[];
}

export const CardContentTags = ({ tags, className }: CardContentTagsProps) => {
  const context = useContext<any>(CardContentContext);
  const tagsStyle = useApplyTagsStyle();

  useEffect(() => context?.setHasTags(true), [context]);

  return (
    <div
      className={classNames(
        'CardContentTag',
        className,
        'flex gap-8 flex-wrap overflow-hidden',
        tagsStyle,
      )}
    >
      {tags?.map((tag, i) => (
        <Fragment key={tag?.title || `unknow-${i}`}>
          {tag ? <Tag {...tag}>{tag?.title}</Tag> : null}
        </Fragment>
      ))}
    </div>
  );
};
